import Vue, { WatchOptions } from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import InputBase from '@/components/inputs/base/InputBase';
// tslint:disable-next-line: no-var-requires
const VueInputMask = require('vue-inputmask').default;
// tslint:disable-next-line: no-var-requires
const Inputmask = require('inputmask');

Vue.use(VueInputMask);

@Component
export default class InputMaskedText extends InputBase<string> {

  /**
   * Complete list of mask config can be found here:
   * https://github.com/RobinHerbots/Inputmask/blob/5.x/lib/inputmask.js
   */
  @Prop() public maskConfig?: object;
  @Prop() public initialValue?: string;
  @Prop() public option?: string;
  protected isComplete: boolean = false;

  protected mounted() {
    this.inputType = 'text';
    this.isComplete = false;
  }

  protected maskCheck(field: any): void {
    this.isComplete = field.target.inputmask.isComplete();
    this.$emit('input-masked-is-valid', this.isComplete);
  }

  /**
   * Override onValueChanged from InputBase
   */
  protected onValueChanged(value: string, oldValue: string) {
    if (oldValue !== value && value !== undefined) {
      const isValid = Inputmask(this.maskConfig).isValid(value);
      if (isValid) {
        this.isComplete = true;
        this.$emit('input-masked-is-valid', this.isComplete);
      }
    }
  }

  protected onFocus() {
    if (!this.value) {
      this.$emit('input', this.initialValue);
    }
  }
  protected onBlur() {
    if (this.value === this.initialValue) {
      this.$emit('input', '');
    }
  }
}
